import html2canvas from "html2canvas";
const exportAsImage = async (el) => {
  const canvas = await html2canvas(el, { scale: 2, willReadFrequently: true });
  return canvas.toDataURL("image/png", 2.0, {
    scale: 2,
    willReadFrequently: true,
  });
};

export default exportAsImage;

// import html2canvas from "html2canvas";
// const exportAsImage = async (el, imageFileName) => {
//   const canvas = await html2canvas(el);
//   const image = canvas.toDataURL("image/png", 1.0);

//   downloadImage(image, imageFileName);
// };
// const downloadImage = (blob, fileName) => {
//   const fakeLink = window.document.createElement("a");
//   fakeLink.style = "display:none;";
//   fakeLink.download = fileName;

//   fakeLink.href = blob;

//   document.body.appendChild(fakeLink);
//   fakeLink.click();
//   document.body.removeChild(fakeLink);

//   fakeLink.remove();
// };

// export default exportAsImage;
